
<template>
  <div class="froot">
    <div class="ffoot" v-if="showFirstLine">
      <div v-bind:style="{ width: getWidthToWaves() }" style="display:inline-block;">
        <div class="pline" v-if="showWavesLegend" style="padding-top: 0.375rem; padding-left:0.25rem;">
          <div class="reslegcurbox aw"></div>
          <div class="ftxt">{{ getCurrentWave() }}</div>
          <div class="reslegcurbox lw"></div>
          <div class="ftxt">{{ getPreviousWave() }}</div>
        </div>
      </div>
      <div class="pc">
        <div class="pline" style="padding-top: 0.375rem;">
          <scale  ref="scale"
                  style="height:0.75rem; width: 100%;"
                  :proportional="true"
                  :showText="false"
                  :smallFont="true"
                  :topdown="false" />
        </div>
      </div>
      <div class="pr">
        <div class="pline"></div>
      </div>
    </div>
    <div class="ffoot" v-if="showSecondLine">
      <div class="pline" style="padding: 0.25rem; width: 100%;">
        <div class="reslegcurbox" style="background-color: #ff201c;"></div>
        <div class="ftxt">{{ tooltipText(0) }}</div>
        <div class="reslegcurbox" style="background-color: #f7850E;"></div>
        <div class="ftxt">{{ tooltipText(1) }}</div>
        <div class="reslegcurbox" style="background-color: #FDF804;"></div>
        <div class="ftxt">{{ tooltipText(2) }}</div>
        <div class="reslegcurbox" style="background-color: #96E524;"></div>
        <div  class="ftxt">{{ tooltipText(3) }}</div>
        <div class="reslegcurbox" style="background-color: #0C891D;"></div>
        <div class="ftxt">{{ tooltipText(4) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import AppConfig from '@/mixins/AppConfig-APP_TARGET';
import PorscheWaves from '@/mixins/PorscheWaves';
import PorscheScale from '@/mixins/PorscheScale';
import scale from './Scale';

export default {
  name: 'Foot',

  components: { scale },

  mixins: [ AppConfig, PorscheWaves, PorscheScale ],

  props: {
    dashdata: { type: Object, default: null, required: true },
    showFirstLine: { type: Boolean, default: true },
    showWavesLegend: { type: Boolean, default: false },
    showSecondLine: { type: Boolean, default: true }
  },

  methods: {
    getPreviousWave() {
      let name = '';
      if (this.dashdata.wavenames.length < 2) {
        name = 'N/A';
      } else {
        if (!_.isEmpty(this.dashdata.OverallByWave[0])) {
          name = this.getPreviousWaveName(this.dashdata.OverallByWave[0]);
        }
      }
      return this.$t('Webportal.PreviousWave') + ': ' + name;
    },

    getCurrentWave() {
      let name = '';
      if (!_.isEmpty(this.dashdata.OverallByWave[0])) {
        name = this.getCurrentWaveName(this.dashdata.OverallByWave[0]);
      }
      return this.$t('Webportal.CurrentWave') + ': ' + name;
    },

    getWidthToWaves() {
      // 7 -> column padding
      // 260 -> Dimension column
      // Each wave will take 150px width
      let retVal = (7 + 260 + this.dashdata.list[0].SurveyWave.length * 150) + 'px';
      return retVal;
    }
  }
};

</script>


<style scoped>

.pline {
  height: 1.5rem;
}

.pl {
  width: 440px; /* or leave it undefined */
}
.pc {
  flex-grow: 1;
  min-width: 250 !important;
}
.pr {
  width: 7px; /* cell padding */
}
.pitem {
  text-align: center;
  height: 1rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  /* width: 300px; */
 /*  */
}

</style>
